export enum CartAction {
  ClearCart = 'clearCart',
  RefreshCart = 'refreshCart',
}

export type CheckoutAuthFormStep =
  | 'signIn'
  | 'existingUser'
  | 'existingUserAfterReset'
  | 'createAccount'
  | 'forgotPassword';
